export default __webpack_public_path__ + "static/quote-2-a5b7f4488089e10e896f2cfbaaf7369a.mp3";